(() => {
  'use strict';

  const widths = [360, 540, 720, 900];

  const isShopifyFileImage = (src) => {
    try {
      const url = new URL(src, window.location.origin);
      return url.hostname === 'cdn.shopify.com' && url.pathname.includes('/files/');
    } catch (error) {
      return false;
    }
  };

  const withWidth = (src, width) => {
    const url = new URL(src, window.location.origin);
    url.searchParams.set('width', String(width));
    return url.toString();
  };

  const optimizeArticleImages = (root) => {
    root.querySelectorAll('.uc-article__content img').forEach((img) => {
      const src = img.getAttribute('src');
      if (!src || !isShopifyFileImage(src)) return;
      if (img.hasAttribute('srcset')) return;

      const base = new URL(src, window.location.origin);
      base.searchParams.delete('width');
      const baseUrl = base.toString();

      img.src = withWidth(baseUrl, 900);
      img.srcset = widths.map((width) => `${withWidth(baseUrl, width)} ${width}w`).join(', ');
      img.sizes = '(max-width: 768px) calc(100vw - 36px), 760px';
      img.loading = 'lazy';
      img.decoding = 'async';
    });
  };

  const pruneProductVideoSources = (root) => {
    root.querySelectorAll('.product-section video').forEach((video) => {
      const sources = Array.from(video.querySelectorAll('source[src]'));
      if (sources.length < 2) return;

      const mp4Sources = sources.filter((source) => source.type === 'video/mp4' || /\.mp4(?:$|\?)/i.test(source.src));
      const chosen = mp4Sources.find((source) => source.src.includes('.HD-720p-'))
        || mp4Sources.find((source) => source.src.includes('.SD-480p-'))
        || mp4Sources[0];

      if (!chosen) return;
      sources.forEach((source) => {
        if (source !== chosen) source.remove();
      });
    });
  };

  const optimize = (root = document) => {
    optimizeArticleImages(root);
    pruneProductVideoSources(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => optimize(document), { once: true });
  } else {
    optimize(document);
  }

  document.addEventListener('shopify:section:load', (event) => optimize(event.target));
})();
